import { Injectable } from '@angular/core';
import { IBotService } from '@hyper-inferno/survey-elements-core-ui';
import {
  SurveyResolverStartPayload,
  ChatMessage,
} from '@hyper-inferno/survey-elements-core-utils';

@Injectable({
  providedIn: 'root',
})
export class PreviewBot implements IBotService {
  handshake(handshakePayload: SurveyResolverStartPayload): Promise<string> {
    throw new Error('Method not implemented.');
  }
  sendAnswerBot(message: ChatMessage): Promise<ChatMessage> {
    throw new Error('Method not implemented.');
  }
  startSurveyTransaction(handshakeToken: string): Promise<ChatMessage> {
    throw new Error('Method not implemented.');
  }
}
